export const useSxStyles = () => {
  return {
    root: {
      height: '100%',
      width: '100%',
      position: 'relative',
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: 'auto 1fr',
      gridTemplateAreas: `
          "sidebar content"
        `,
    },
    sidebar: {
      gridArea: 'sidebar',
      overflow: 'hidden',
    },
    content: {
      gridArea: 'content',
      overflow: 'auto',
    },
  };
};
